// extracted by mini-css-extract-plugin
export default {"title":"AuthForm_title__aYIVq","auth":"AuthForm_auth__PhU81","control":"AuthForm_control__ZfScu","actions":"AuthForm_actions__n9FBA","toggle":"AuthForm_toggle__5ryRp"};